import React from "react";
import { newLineToBr } from "../../utilities";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

interface Props {
  product: server.dto.Product
  onChecked: (product: server.dto.Product) => void
  checked: boolean
}

const SelectProduct = (props: Props) => {
  const { product, checked, onChecked } = props;

  return <div className="flex padding-large panel-bg-color margin-bottom-small">
    <div className="grow1">
      <Checkbox
        label={<div>
          {product.titleFormatted}
          <div className="text-sublabel">{newLineToBr(product.description)}</div>
        </div>}
        checked={checked}
        onChange={() => { onChecked(product); }}
      />
    </div>
    {(product.sales) && <div className="nowrap">
      {product.sales.totalExVat.formatted}
    </div>}
  </div>;
};

export default SelectProduct;